/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-03-10 11:30:23
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-12 17:35:48
 * @FilePath: /wemeet-admin-new/src/api/workBench.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'
// 获取小程序所有数接口
export function getMiniData(data) {
  return request({
    url: '/user/admin/platform/report/mp',
    method: 'POST',
    data,
  })
}

// 获取平台所有数接口
export function getPlatformData(data) {
  return request({
    url: '/user/admin/platform/report/md',
    method: 'POST',
    data,
  })
}

// 获取平台所有会接口
export function getPlateAllData(params) {
  return request({
    url: '/user/platform/report/getMeetingList',
    method: 'GET',
    params,
  })
}

// 获取办个会接口
export function getAllHoldMeet(data) {
  return request({
    url: '/user/admin/platform/report/meeting/queryList',
    method: 'POST',
    data,
  })
}

// 获取办个会接口
export function getAllHoldMeetByEnterpirseCode(data) {
  return request({
    url: '/user/enterprise/meeting/list',
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取平台所有的入驻企业列表
 * @param {*} params
 * @return {*}
 */
export function getAllEnterprise(params) {
  return request({
    url: '/user/admin/enterprise/query',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取企业下所有展览
 * @param {*} params
 * @return {*}
 */
export function getAllExhByEnterprise(params) {
  return request({
    url: '/user/admin/enterprise/queryExhibition',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取企业下所有会议
 * @param {*} params
 * @return {*}
 */
export function getAllMeetByEnterprise(params) {
  return request({
    url: '/user/admin/enterprise/queryMeeting',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下所有基础数据
 * @param {*} params
 * @return {*}
 */
export function reportMeetingStatistics(params) {
  return request({
    url: '/user/admin/event/report/meeting/statistics',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下趋势分析
 * @param {*} params
 * @return {*}
 */
export function reportMeetingTrendAnalysis(data) {
  return request({
    url: '/user/admin/event/report/meeting/trendAnalysis',
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取展/会下用户身份
 * @param {*} params
 * @return {*}
 */
export function reportMeetingIdentity(params) {
  return request({
    url: '/user/admin/event/report/meeting/identity',
    method: 'GET',
    params,
  })
}
/**
 * @description: 获取展/会下实名用户
 * @param {*} params
 * @return {*}
 */
export function reportMeetingRealName(params) {
  return request({
    url: '/user/admin/event/report/meeting/realName',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下地域分布
 * @param {*} params
 * @return {*}
 */
export function reportMeetingRegional(params) {
  return request({
    url: '/user/admin/event/report/meeting/regional',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下问卷
 * @param {*} params
 * @return {*}
 */
export function reportMeetingQuestionnaire(params) {
  return request({
    url: '/user/admin/event/report/meeting/questionnaire',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下Ai 助理
 * @param {*} params
 * @return {*}
 */
export function reportMeetingaiAgentData(data) {
  return request({
    url: '/user/admin/event/report/meeting/aiAgentData',
    method: 'POST',
    data,
  })
}
/**
 * @description: 获取展/会下渠道线图数据
 * @param {*} params
 * @return {*}
 */
export function reportMeetingChannelCharts(params) {
  return request({
    url: '/user/admin/event/report/meeting/channel/charts',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下渠道列表
 * @param {*} params
 * @return {*}
 */
export function reportMeetingChannelList(params) {
  return request({
    url: '/user/admin/event/report/meeting/channelList',
    method: 'GET',
    params,
  })
}

/**
 * @description: 获取展/会下渠道详情
 * @param {*} params
 * @return {*}
 */
export function reportMeetingChannelDetail(data) {
  return request({
    url: '/user/admin/event/report/meeting/channel/detail',
    method: 'POST',
    data,
  })
}

/**
 * @description: 日报详情
 * @param {*} params
 * @return {*}
 */
export function reportMeetingDailyDetail(data) {
  return request({
    url: '/user/admin/event/report/meeting/dailyDetail',
    method: 'POST',
    data,
  })
}
